import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

const {
	colors,
	common: { borderRadius, border },
	spacing: { xs, sm },
} = THEME;

export const styleSheet = StyleSheet.create({
	wrapper: {
		gap: xs,
	},
	container: {
		alignItems: 'center',
		gap: xs,
		border,
		borderRadius,
		padding: sm,
		backgroundColor: colors.background.main,
		minHeight: 40,
		flexWrap: 'wrap',
	},
	iconButton: {
		padding: `${xs}px ${sm}px`,
		backgroundColor: colors.primary.main,
		maxHeight: 'fit-content',
		borderRadius: 4,
		':hover': {
			backgroundColor: colors.hover.main,
		},
		':active': {
			backgroundColor: colors.primary.dark,
		},
	},
	linkButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		maxWidth: 'fit-content',
		padding: '4px 0px',
		gap: xs,
	},
	buttonLabel: {
		color: colors.primary.main,
	},
	popoverContent: {
		maxWidth: 450,
		maxHeight: '35vh',
		overflowY: 'scroll',
		borderRadius,
		'::-webkit-scrollbar': {
			background: 'transparent',
			width: 9,
		},
		'::-webkit-scrollbar-thumb': {
			borderRadius,
			backgroundColor: colors.border.main,
			boxShadow: '0 0 1px rgba(255, 255, 255, .5)',
		},
	},
	inputRow: {
		gap: 4,
		flexWrap: 'nowrap',
		whitespace: 'nowrap',
	},
	infoText: {
		color: colors.text.light,
		fontSize: 14,
	},
	textInput: {
		outline: 'none',
		border: 'none',
		padding: 0,
		width: 'auto',
		minWidth: 20,
	},
});
